import { render, staticRenderFns } from "./ListProposal.vue?vue&type=template&id=282d8c62&scoped=true"
import script from "./ListProposal.vue?vue&type=script&lang=js"
export * from "./ListProposal.vue?vue&type=script&lang=js"
import style0 from "./ListProposal.vue?vue&type=style&index=0&id=282d8c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d8c62",
  null
  
)

export default component.exports